module.exports = __webpack_public_path__ + "img/foto.f0675f72.png";